<!--header-->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      Proton Therapy Plans
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>

<ion-content>
  <!--tabulator-->
  <ion-segment fill="outline" color="medium" [(ngModel)]='activePlan'>
    <ion-segment-button value='forecast'>
      Forecast
    </ion-segment-button>
    <ion-segment-button value='1715'>
      Shifts 1715
    </ion-segment-button>
    <ion-segment-button value='cptcalendar'>
      Calendar
    </ion-segment-button>
  </ion-segment>
  <div [ngSwitch]="activePlan" style="height:90%;">
    <!--cpt forecast image-->
    <div *ngSwitchCase="'forecast'" style="height: 100%;">
      <pinch-zoom height="100%">
        <img id="forecastimage" [src]="zptforecast" alt="Forecast Screenshot" />
      </pinch-zoom>
    </div>
    <!--cpt shifts 1715 image-->
    <div *ngSwitchCase="'1715'" style="height: 100%;">
      <pinch-zoom height="100%">
        <img id="forecastimage" [src]="zptshifts" alt="Shifts 1715" />
      </pinch-zoom>
    </div>
    <!--cpt calendar link-->
    <div *ngSwitchCase="'cptcalendar'">
      <ion-card-content>
        <ion-icon name="calendar"></ion-icon>
        <h1>This view is not available at the moment at PSI Pocket.</h1>
        <ion-button color="dark" expand="full" href="http://spotscan.ch/CPTcalendar/">
          Go to the CPT calendar
        </ion-button>
      </ion-card-content>
    </div>
  </div>
  <!--update image button-->
  <ion-fab vertical="bottom" (click)="doRefresh()" horizontal="end" slot="fixed">
    <ion-fab-button color="dark">
      <ion-icon *ngIf="!refreshIcon" name="refresh"></ion-icon>
      <ion-spinner *ngIf="refreshIcon" name="dots"></ion-spinner>
    </ion-fab-button>
  </ion-fab>
</ion-content>